export default "__VITE_ASSET__cUoU7OFq__"